import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  private _errorMessage$ = new BehaviorSubject<string>(null);

  public get errorMessage$(): Observable<string> {
    return this._errorMessage$.asObservable();
  }

  public setErrorMessage(message: string): void {
    this._errorMessage$.next(message);
  }
}
